var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:({width: _vm.size + 'px', height: _vm.size + 'px'})},[_c('use',_vm._b({},'use',{
      'href': require('../assets/icons.svg') + '#' + _vm.name,
      'xlink:href': require('../assets/icons.svg') + '#' + _vm.name
    },false))])}
var staticRenderFns = []

export { render, staticRenderFns }